import axios from "axios";
import { authHeaderFile, authHeaderJson } from "../auth-header.service";

const getAllTickets = () => {
    return axios.get(`/api/ticket/list`, { headers: authHeaderJson() } );
};

const updateTicket = (id, itemTicket) => {
    return axios.put(`/api/ticket/update/${id}`, itemTicket, { headers: authHeaderJson() } )
};

const deleteTicket = (ticketid) => {
    return axios.delete(`/api/ticket/delete/${ ticketid }`, { headers: authHeaderJson() });
};

const addTicket = (itemTicket) => {
    return axios.post(`/api/ticket/add`, itemTicket, { headers: authHeaderJson() } )
};

const getAllTicketAnswers = (ticket_id) => {
    return axios.get(`/api/ticket/answerlist/${ticket_id}`, { headers: authHeaderJson() } );
};

const addTicketAnswer = (itemTicketAnswer) => {  
    return axios.post(`/api/ticket/answeradd`, itemTicketAnswer, { headers: authHeaderJson() } )
};

const getTicketDocuments = (ticket_id, ticket_answer_id) => {    
    //[##PATH ROUTE##]
    //return axios.get(`/api/ticket/ticketDocument/${ticket_id}/list`, { headers: authHeaderJson(), params: {ticket_answer_id: ticket_answer_id  } } );
    return axios.get(`/api/ticket/ticketDocument/${ticket_id}/${ticket_answer_id}/list`, { headers: authHeaderJson() } );
};

export {
    getAllTickets,
    updateTicket,
    deleteTicket,
    addTicket,
    getAllTicketAnswers,
    addTicketAnswer,
    getTicketDocuments
}


// const ApiTicketService = {
//     fetchItems: async () => {
//       try {
//         const response = await axios.get(`${API_URL}/ticket/list`, { headers: authHeader() } );
//         return response.data;
//       } catch (error) {
//         console.error('Error fetching items:', error);
//         throw error;
//       }
//     },
  
//     updateItem: async (item) => {
//       try {
//         const response = await axios.put(`${API_URL}/ticket/ticketupdate`, item, { headers: authHeader() } )
//         return response.data;
//       } catch (error) {
//         console.error('Error saving item:', error);
//         throw error;
//       }
//     },
  
//     deleteTicket: async (id) => {
//       try {
//         const response = await axios.delete(`${API_URL}/ticket/ticketdelete/${ id }`, { headers: authHeader() });
//         return response.data;
//       } catch (error) {
//         console.error('Error saving item:', error);
//         throw error;
//       }
//     },
  
//     saveItem: async (item) => {
//       try {
//         const response = await axios.post(`${API_URL}/ticket/ticketadd`, item, { headers: authHeader() } )
//         return response.data;
//       } catch (error) {
//         console.error('Error saving item:', error);
//         throw error;
//       }
//     },
    
//   };
  
//   export default ApiTicketService;